<template>
  <div class="h-screen w-screen" v-if="authStatus === 'authenticating'">
    <div class="h-full flex items-center justify-center">
        <img src="@/assets/bdglogistica_isotipo.png" class="h-24 animate-pulse">
      </div>
  </div>
  <router-view v-else />
</template>

<script>
  import useAuth from './modules/auth/composables/useAuth'

  export default {
    setup() {
      const { authStatus, checkAuthStatus } = useAuth()

      checkAuthStatus()

      return {
        authStatus
      }
    },
  }
</script>